module.exports = __webpack_public_path__ + "static/img/15.9053e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/15.png
// module id = Xt5I
// module chunks = 0